export default __webpack_public_path__ + "static/media/code-hosting.c2badc67.gif";